function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.93 12c0 4.373-3.557 7.93-7.93 7.93-4.373 0-7.93-3.557-7.93-7.93 0-4.373 3.557-7.93 7.93-7.93 4.373 0 7.93 3.557 7.93 7.93Zm1.67 0c0-5.293-4.307-9.6-9.6-9.6-5.293 0-9.6 4.307-9.6 9.6 0 5.293 4.307 9.6 9.6 9.6 5.293 0 9.6-4.307 9.6-9.6Zm-8.09-4.164a1.05 1.05 0 0 0 .306-.736c0-.276-.111-.545-.305-.739a1.05 1.05 0 0 0-1.476 0 1.044 1.044 0 1 0 1.476 1.475Zm-2.072 9.968a.731.731 0 0 1-.717-.872l1.028-5.22-.566.32a.73.73 0 1 1-.717-1.273l1.948-1.098a.73.73 0 0 1 1.075.778l-1.065 5.408.873-.38a.73.73 0 0 1 .584 1.339l-2.152.937a.732.732 0 0 1-.291.06Z",
  fill: "#A8A8A8"
});

function SvgInfoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/info-gray.9e62e742.svg";
export { ForwardRef as ReactComponent };